inlineClass